module.exports = __webpack_public_path__ + "static/media/yes.738dad39.svg";